<template>
  <v-layout row wrap v-if="data">
    <v-flex xs12 text-xs-center title>
      血氧分析报告
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs6 md4 class="outline">
      <div>报告日期:</div>
      <div>开始时间:</div>
      <div>总时间:</div>
    </v-flex>

    <v-flex xs6 md8>
      <div>{{ data.timeStart | yymmddFormat }}</div>
      <div>{{ data.timeStart | hhmmssFormat }}</div>
      <div>{{ data.duration | secondsToHHMMSS }}</div>
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs6 md4>
      <div>平均血氧饱和度(%):</div>
      <div>最低血氧饱和度(%):</div>
      <!-- <div>最长氧减时间(s):</div> -->
      <div>氧减次数:</div>
      <div>氧减指数:</div>
    </v-flex>

    <v-flex xs6 md8>
      <div>{{ data.spo2Avg / 100 }} </div>
      <div>{{ data.spo2Min / 100 }} </div>
      <!-- <div>{{ data.maxSpo2DownTime }} </div> -->
      <div>{{ data.diffThdLge3Cnts }} </div>
      <div>{{ data.diffThdLge3Pr | floatToFixed }} </div>
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs4>
      <div>血氧饱和度</div>
      <div> ＜95%: </div>
      <div> ＜90%: </div>
      <div> ＜85%: </div>
      <div> ＜80%: </div>
      <div> ＜70%: </div>
      <div> ＜60%: </div>
    </v-flex>

    <v-flex xs4>
      <div>时间(s)</div>
      <div> {{ data.spo2Less95Time | secondsToHHMMSS }} </div>
      <div> {{ data.spo2Less90Time | secondsToHHMMSS }} </div>
      <div> {{ data.spo2Less85Time | secondsToHHMMSS }} </div>
      <div> {{ data.spo2Less80Time | secondsToHHMMSS }} </div>
      <div> {{ data.spo2Less70Time | secondsToHHMMSS }} </div>
      <div> {{ data.spo2Less60Time | secondsToHHMMSS }} </div>
    </v-flex>

    <v-flex xs4>
      <div>占比(%)</div>
      <div> {{ data.spo2Less95TimePercent | percentFormat }} </div>
      <div> {{ data.spo2Less90TimePercent | percentFormat }} </div>
      <div> {{ data.spo2Less85TimePercent | percentFormat }} </div>
      <div> {{ data.spo2Less80TimePercent | percentFormat }} </div>
      <div> {{ data.spo2Less70TimePercent | percentFormat }} </div>
      <div> {{ data.spo2Less60TimePercent | percentFormat }} </div>
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs6 md4>
      <div>平均脉率(bpm): </div>
      <div>最大脉率(bpm): </div>
      <div>最小脉率(bpm): </div>
    </v-flex>

    <v-flex xs6 md8>
      <div> {{ data.prAvg }} </div>
      <div> {{ data.prMax }} </div>
      <div> {{ data.prMin }} </div>
    </v-flex>

    <v-flex xs12 mt-2 mb-2>
      <v-divider></v-divider>
    </v-flex>

    <v-flex xs12>
      <div>血氧饱和度趋势图</div>

      <ve-line :data="chartDataSpo" :colors="colorsSpo" :loading="loading"
        :grid="grid"
        :mark-line="markLine"
        :tooltip-visible="false"
        :legend-visible="false"
        height="250px"
        :settings="chartSettings"
        :extend="chartExtendSpo"></ve-line>

      <div>脉率趋势图</div>

      <ve-line :data="chartDataPr" :colors="colorsPr" :loading="loading"
        :grid="grid"
        :mark-line="markLine"
        :tooltip-visible="false"
        :legend-visible="false"
        height="250px"
        :settings="chartSettings"
        :extend="chartExtendPr"></ve-line>

      <div>睡眠分期图</div>

      <ve-line :data="chartDataStage" :colors="colorsPr" :loading="loading"
        :grid="grid"
        :tooltip-visible="false"
        :legend-visible="false"
        height="250px"
        :settings="chartSettings"
        :extend="chartExtendStage"></ve-line>
    </v-flex>

    <v-flex xs2>分期统计</v-flex>
    <v-flex xs2>清醒期</v-flex>
    <v-flex xs2>眼动期</v-flex>
    <v-flex xs2>浅睡期</v-flex>
    <v-flex xs2>深睡期</v-flex>
    <v-flex xs2></v-flex>

    <v-flex xs2>时长(min)</v-flex>
    <v-flex xs2>{{ data.wMinutes }}</v-flex>
    <v-flex xs2>{{ data.rMinutes }}</v-flex>
    <v-flex xs2>{{ data.lMinutes }}</v-flex>
    <v-flex xs2>{{ data.dMinutes }}</v-flex>
    <v-flex xs2></v-flex>

    <v-flex xs2>占比(%)</v-flex>
    <v-flex xs2>{{ data.wPercent | stagePercentFormate }}</v-flex>
    <v-flex xs2>{{ data.rPercent | stagePercentFormate }}</v-flex>
    <v-flex xs2>{{ data.lPercent | stagePercentFormate }}</v-flex>
    <v-flex xs2>{{ data.dPercent | stagePercentFormate }}</v-flex>
    <v-flex xs2></v-flex>
  </v-layout>
</template>

<script>
import { dateFormat } from '@/utils/Util'
import 'v-charts/lib/style.css'
import 'echarts/lib/component/markLine'

// const mockSleepData = [0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

function format (date) {
  let h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  let m = date.getMinutes()
  m = m < 10 ? ('0' + m) : m
  return h + ':' + m
}

function minBottom (v, min) {
  const tmp = Math.floor(v / 10) * 10
  return tmp - 10 < min ? min : tmp
}

function maxTop (v, max) {
  const tmp = Math.ceil(v / 10) * 10
  return tmp + 10 > max ? max : tmp
}

export default {
  props: [
    'data'
  ],
  data () {
    this.chartSettings = {}
    this.colorsSpo = ['#00a3fb']
    this.colorsPr = ['#00c651']

    this.chartExtendSpo = {
      animation: false,
      xAxis: {
        axisLabel: {
          showMaxLabel: true,
          // rotate: 40,
          formatter: function (value, index) {
            var t = new Date(value * 1000)
            return format(t)
          }
        }
      },
      yAxis: {
        min (v) {
          // return v.min - 10 < 0 ? 0 : v.min - 10
          return minBottom(v.min, 40)
        },
        max: 100,
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        }
      },
      series: {
        showSymbol: false,
        lineStyle: {
          normal: {
            // color: ,
            width: 1
          }
        }
      }
    }
    this.chartExtendPr = {
      animation: false,
      xAxis: {
        axisLabel: {
          showMaxLabel: true,
          // rotate: 40,
          formatter: function (value, index) {
            var t = new Date(value * 1000)
            return format(t)
          }
        }
      },
      yAxis: {
        min (v) {
          // return v.min - 10 < 30 ? 30 : v.min - 10
          return minBottom(v.min, 30)
        },
        max (v) {
          // return v.max + 10 > 240 ? 240 : v.max + 10
          return maxTop(v.max, 240)
        },
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        }
      },
      series: {
        showSymbol: false,
        lineStyle: {
          normal: {
            // color: ,
            width: 1
          }
        }
      }
    }

    this.chartExtendStage = {
      animation: false,
      xAxis: {
        axisLabel: {
          showMaxLabel: true,
          // rotate: 40,
          formatter: function (value, index) {
            var t = new Date(value * 1000)
            return format(t)
          }
        }
      },
      yAxis: {
        align: 'left',
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },
        interval: 1
      },
      'yAxis.0.axisLabel.formatter': (v) => v === 4 ? 'W' : v === 3 ? 'R' : v === 2 ? 'L' : v === 1 ? 'D' : '',
      'yAxis.0.min': 1,
      'yAxis.0.max': 4,
      series: {
        step: 'end',
        showSymbol: false,
        smooth: false,
        lineStyle: {
          normal: {
            // color: ,
            width: 1
          }
        }
      }
    }

    this.markLine = {
      data: [],
      symbol: 'image://',
      silent: true,
      label: {
        normal: {
          position: 'end',
          formatter: function () {
            return ''
          }
        }
      },
      lineStyle: {
        normal: {
          color: '#333'
        }
      }
    }
    this.grid = {
      top: 20,
      bottom: 30,
      right: 30
    }
    return {
      chartDataSpo: {
        columns: ['时间', 'spo2'],
        rows: []
        // [
        //   { '时间': '1/1', 'spo2': 1393 },
        // ]
      },
      chartDataPr: {
        columns: ['时间', 'pr'],
        rows: []
      },
      chartDataStage: {
        columns: ['时间', 'stage'],
        rows: []
      },
      loading: true
    }
  },
  filters: {
    floatToFixed (value) {
      return Number(value).toFixed(2)
    },
    percentFormat (value) {
      return (value).toFixed(2)
    },
    secondsToHHMMSS (value) {
      if (value <= -1) {
        return '(无有效数据)'
      }
      return new Date(value * 1000).toUTCString().slice(-12, -4)
    },
    yymmddFormat (value) {
      return dateFormat(new Date(value * 1000), 'yyyy-MM-dd')
    },
    hhmmssFormat (value) {
      return dateFormat(new Date(value * 1000), 'hh:mm:ss')
    },
    stagePercentFormate (value) {
      return value ? value.toFixed(2) : 0
    }
  },
  mounted: function () {
    const startTime = this.data.timeStart

    // 处理-血氧解析
    const totalLen = this.data.spoArr.length
    const rowsSpo = []
    const rowsPr = []
    for (let i = 0; i < totalLen; i++) {
      rowsSpo.push({'时间': startTime + i, 'spo2': this.data.spoArr[i] <= 0 ? '' : this.data.spoArr[i] / 100})
      rowsPr.push({'时间': startTime + i, 'pr': this.data.prArr[i] || ''})
    }
    this.chartDataSpo.rows = rowsSpo
    this.chartDataPr.rows = rowsPr
    this.markLine.data = this.data.handOffArr.map(v => ({ xAxis: v }))

    // 处理-睡眠分期 mock
    // const sleepLen = mockSleepData.length
    // const rowsStage = []
    // for (let i = 0; i < sleepLen; i++) {
    //   rowsStage.push({'时间': startTime + i * 60, 'stage': mockSleepData[i] === 0 ? 4 : 5 - mockSleepData[i]})
    // }
    // console.log(rowsStage)
    // this.chartDataStage.rows = rowsStage

    const d = {1: 0, 2: 0, 3: 0, 4: 0}

    const stageLen = this.data.stageArr.length
    if (this.data.stageArr && stageLen > 0) {
      const sleepLen = stageLen
      const rowsStage = []
      for (let i = 0; i < sleepLen; i++) {
        const v = this.data.stageArr[i] === 0 ? 4 : 5 - this.data.stageArr[i]
        rowsStage.push({'时间': startTime + i * 60, 'stage': v})
        d[v]++
      }
      this.data.wMinutes = d[4]
      this.data.rMinutes = d[3]
      this.data.lMinutes = d[2]
      this.data.dMinutes = d[1]

      const stageTotal = d[4] + d[3] + d[2] + d[1]
      this.data.wPercent = d[4] * 100 / stageTotal
      this.data.rPercent = d[3] * 100 / stageTotal
      this.data.lPercent = d[2] * 100 / stageTotal
      this.data.dPercent = d[1] * 100 / stageTotal

      this.chartDataStage.rows = rowsStage
    }
    this.loading = false
  }
  // watch: {
  //   data (res) {
  //     if (!res) {
  //       return
  //     }
  //     const startTime = res.timeStart

  //     // 处理-血氧解析
  //     const totalLen = res.spoArr.length
  //     const rowsSpo = []
  //     const rowsPr = []
  //     for (let i = 0; i < totalLen; i++) {
  //       rowsSpo.push({'时间': startTime + i, 'spo2': res.spoArr[i] <= 0 ? '' : res.spoArr[i] / 100})
  //       rowsPr.push({'时间': startTime + i, 'pr': res.prArr[i] || ''})
  //     }
  //     this.chartDataSpo.rows = rowsSpo
  //     this.chartDataPr.rows = rowsPr
  //     this.markLine.data = res.handOffArr.map(v => ({ xAxis: v }))

  //     // 处理-睡眠分期
  //     const sleepLen = mockSleepData.length
  //     const rowsStage = []
  //     for (let i = 0; i < sleepLen; i++) {
  //       rowsStage.push({'时间': startTime + i * 60, 'stage': mockSleepData[i] === 0 ? 4 : 5 - mockSleepData[i]})
  //     }
  //     console.log(rowsStage)
  //     this.chartDataStage.rows = rowsStage

  //     this.loading = false
  //   }
  // }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ParsedPanel.vue